// function getModules() {
//   let _module = {};
//   const modules = require.context("./module", false, /\.js$/);
//   modules.keys().forEach(key => {
//     let _m = modules(key);
//     _module[Object.keys(_m)[0]] = _m[Object.keys(_m)[0]];
//   });
//   return _module;
// }

// export default getModules();
import { account } from "./module/account";
import { cash } from "./module/cash";
import { client } from "./module/clinetmanage";
import { common } from "./module/common";
import { hrlist } from "./module/hrmanage";
import { hunter } from "./module/hunter";
import { hunterorder } from "./module/hunterorder";
import { order } from "./module/order";
import { office } from "./module/organization";
import { position } from "./module/position";
import { post } from "./module/post";
import { resume } from "./module/resume";
import { system } from "./module/system";
import { dashboard } from './module/dashboard'
import { im } from './module/im'

export default {
  account,
  cash,
  client,
  common,
  hrlist,
  hunter,
  hunterorder,
  order,
  office,
  position,
  post,
  resume,
  system,
  dashboard,
  im
};
